import type { LeaseActionProps } from '../../../models/Types';
import LeaseExtension from '../../../models/LeaseExtension';
import { useLeasingUrlParams } from '../../../hooks/useLeasingUrlParams';

export default function RedirectToLeaseExtensionPDFView({ history, terminateActiveAction, lease }: LeaseActionProps) {
  const { renewalId, leaseId } = useLeasingUrlParams();
  const latestExtension = lease?.latestExtension ? new LeaseExtension(lease.latestExtension) : null;

  const extensionId = renewalId || latestExtension?.id || 0;

  history.push(LeaseExtension.getPreviewPath(leaseId || lease.id, extensionId));
  terminateActiveAction();
  return null;
}
